import { TextValidator, ValidatorComponentProps } from 'react-material-ui-form-validator';

interface ITextValidatorHcs extends ValidatorComponentProps {
    shrink?: boolean
}

export const TextValidatorHcs = (params: ITextValidatorHcs) => {
    const value =
        params.value === undefined || params.value === null ? "" : params.value;
    const shrinkFromValueType =
        (params.value !== undefined &&
            params.value !== null &&
            params.value !== "") ||
        params.type === "date" ||
        params.type === "file" ||
        params.type === "number";
    const shrink =
        params.InputLabelProps?.shrink ??
        params.shrink ??
        shrinkFromValueType;

    return (
        <TextValidator
            {...params}
            value={value}
            InputLabelProps={{ ...params.InputLabelProps, shrink }}
        />
    );
}

